<script>
  import Log from '@utils/log';
  import Notification from '@utils/notification';
  import Track from '@utils/track';
  import { getCurrentUserStore } from '@stores/current_user';
  import jQuery from 'jquery';
  import { createEventDispatcher } from 'svelte';
  const dispatch = createEventDispatcher();

  export let group;
  export let mobile;
  export let relatedUserId;

  let shareInput;
  let currentUser = getCurrentUserStore('default');

  let logCopyLink = function () {
    Log.info(
      `SHARE: List Link Copied (who shared: ${currentUser && currentUser.name}, list: ${group.name} | ${group.url})`
    );
  };

  let copyLink = function () {
    if (mobile && typeof navigator !== 'undefined' && typeof navigator.share != 'undefined') {
      navigator
        .share({ title: group.name, url: group.url })
        .then(() => {})
        .catch(() => {});
    } else {
      jQuery(shareInput).css('display', 'block');
      shareInput.select();
      shareInput.setSelectionRange(0, 9999);
      document.execCommand('copy');
      jQuery(shareInput).css('display', 'none');

      Notification.send({ text: 'Link copied ' });
      dispatch('link-copied');
    }
    if (relatedUserId) {
      Track.groupCopyLink({ currentUser, group, relatedUserId });
    } else {
      Track.inviteCopyLink({ currentUser, group });
    }
    logCopyLink();
  };
</script>

<div>
  <input
    type="text"
    style="display: none"
    bind:this={shareInput}
    value={group.privacy_flag == 'public' ? group.url : null} />
  <span on:click={copyLink} on:keydown={copyLink}>
    <slot />
  </span>
</div>
